// src/termcondition.js
import { Navigate } from 'react-router-dom';

import './App.css';

const termcondtions = () => {
  return (
    
    <div className="about-page">

      {/* Hero Section */}
    <section className="heronew">
      <img src="img/blogleft.png" className="vectorall-left desktopvector" alt="left vector" />
  <img src="img/m2.png" className="vectorall-left mobilevector" alt="left vector" />
  
  <div className="hero-content">
  <h1 className="headline">
  <span style={{ color: '#2F2F2F' }}>Terms And Conditions</span>
</h1>

  </div>


</section>

  {/* How we got started */}
      <section className="termcondtion-section">
        <h2 className='newsection'>1. Introduction</h2>
        <p>Welcome to Paushtikk Switch! These terms and conditions outline the rules and regulations for the use of our website and services for one-time meal orders. By placing an order through our website, you accept these terms and conditions in full. If you disagree with any part of these terms and conditions, please do not place an order.</p>
<br/>
<h2 className='newsection'>2. Services</h2>
<p>Paushtikk Switch Private Limited provides fresh, healthy, and quantified meal delivery services designed to support your fitness and wellness goals.</p>
      
      <br/>
<h2 className='newsection'>3. Order Process</h2>
<p>- Orders can be placed through our website or authorized online platforms.<br/>- Once your order is placed, you will receive a confirmation email with the details of your order.</p>    
 <br/>
<h2 className='newsection'>4. Shipping and Delivery</h2>
<p>- We strive to deliver your meals within 30 minutes to 1 hour of placing your order.<br/>
- Delivery times may vary based on location, traffic conditions, and other factors beyond our control. We appreciate your understanding and patience.<br/>
- If there are any delays, we will notify you as soon as possible.</p>  
 <br/>
<h2 className='newsection'>5. Payment</h2>
<p>- Payment for orders must be made at the time of placing the order.<br/>
- We accept various payment methods, including credit/debit cards, net banking, and other available payment methods on our platform.</p>  
 <br/>
<h2 className='newsection'>6. Refund Policy</h2>
<p>- If you are not satisfied with our service, you may request a refund within 5-7 working days of the delivery date.<br/>
- Refunds will be processed back to the original payment method used during the purchase.<br/>
- To request a refund, please contact our customer service team at makemeswitch@paushtikkswitch.com with your order details and the reason for the refund.</p> 
<br/>
<h2 className='newsection'>7. Cancellation Policy</h2>
<p>- Orders can be canceled up to 1 hour before the scheduled delivery time.<br/>
- Cancellations made after this period may not be eligible for a refund.</p> 
<br/>
<h2 className='newsection'>8. Privacy Policy</h2>
<p>- Your privacy is important to us. We are committed to protecting your personal information and ensuring its confidentiality.<br/>
- Please refer to our Privacy Policy for detailed information on how we collect, use, and protect your data.</p> 
<br/>
<h2 className='newsection'>9. Modifications to the Service and Prices</h2>
<p>- Prices for our products are subject to change without notice.<br/>
- We reserve the right to modify or discontinue the service (or any part or content thereof) without notice at any time</p> 
<br/>
<h2 className='newsection'>10. Governing Law</h2>
<p>-These terms and conditions are governed by and construed in accordance with the laws of India, and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>   
<br/>
<h2 className='newsection'>11. Contact Information</h2>
<p>-For any queries or concerns regarding these terms and conditions, please contact us at makemeswitch@paushtikkswitch.com.</p>   
<br/>
<h2 className='newsection'>12. Parent Company</h2>
<p>- Paushtikk Switch is a brand owned and operated by Paushtikk Switch Private Limited.<br/>By placing an order through our website, you agree to comply with and be bound by these terms and conditions. Thank you for choosing Paushtikk Switch for your nutritional needs.</p>   
 
      </section>

    </div>
  );
};

export default termcondtions;